import React from 'react'
import PropTypes from 'prop-types'
import { Modal, ModalBody } from 'reactstrap'
import classNames from 'classnames'

import PayerCommunityForm from 'shared/components/community/components/payer-form/PayerCommunityForm'

import { SIZES } from '@elo-kit/constants/general.constants'

import './community-welcome-modal.scss'

export const RegisterContent = (props) => {
  const { community, toggle } = props
  const { name, title, welcomeMessage, cover: communityCover = [] } = community
  const { cropped, original } = communityCover[0] || {}

  return (
    <div className='community-welcome-modal__register-container'>
      <div className='community-welcome-modal__left-container'>
        <div className='community-welcome-modal__title'>
          {cropped || original ? (
            <img src={cropped || original} className='community-welcome-modal__title--image' alt='community-icon' />
          ) : (
            <i className='far fa-image community-editable-image__square community-editable-image__no-image' />
          )}
          <div className='community-welcome-modal__title--text'>{name}</div>
        </div>
        <div className='community-welcome-modal__welcome-container'>
          <div className='community-welcome-modal--welcome-title'>{title}</div>
          <div className='community-welcome-modal--welcome-message'>{welcomeMessage}</div>
        </div>
        <div
          className='community-welcome-modal__terms-and-conditions'
          dangerouslySetInnerHTML={{
            __html: I18n.t('react.shared.community.terms_and_conditions'),
          }}
        />
      </div>
      <div className='community-welcome-modal__right-container'>
        <div className='community-welcome-modal__profile-widget'>
          <div className='community-welcome-modal--profile-title'>{I18n.t('react.shared.community.setup_profile')}</div>
          <PayerCommunityForm
            toggle={toggle}
            submitButtonChild={I18n.t('react.shared.button.continue')}
            cancelButtonChild={I18n.t('react.shared.button.cancel')}
            communityId={community.id}
            inModal
          />
        </div>
      </div>
    </div>
  )
}

export const CommunityWelcomeModal = (props) => {
  const { children, className, isOpen, size, toggle, onOpened, community } = props

  const modalClasses = classNames(`community-welcome-modal community-welcome-modal--${size}`, className)

  return (
    <Modal isOpen={isOpen} className={modalClasses} onOpened={onOpened}>
      <ModalBody>{children || <RegisterContent toggle={toggle} community={community} />}</ModalBody>
    </Modal>
  )
}

CommunityWelcomeModal.displayName = 'CommunityWelcomeModal'
CommunityWelcomeModal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element, PropTypes.array]),
  size: PropTypes.string,
  submitDisabled: PropTypes.bool,
  className: PropTypes.string,
  isOpen: PropTypes.bool,
  submit: PropTypes.func,
  toggle: PropTypes.func,
  onOpened: PropTypes.func,
}
CommunityWelcomeModal.defaultProps = {
  submitButtonChild: I18n.t('react.shared.button.save'),
  size: SIZES.medium,
  submitDisabled: false,
}
